import { LuCompass } from 'react-icons/lu';
import { ButtonLink } from '../ui/Button';
import { EmptyState } from '../ui/Feedback';
import { useDocumentTitle, useStrings } from '../tenant/TenantProvider';

export function NotFoundPage() {
  const t = useStrings();
  useDocumentTitle(t('common.notFoundTitle'));
  return (
    <div className="not-found">
      <EmptyState
        icon={LuCompass}
        title={t('common.notFoundTitle')}
        text={t('common.notFoundText')}
        action={
          <ButtonLink to="/problems" variant="primary">
            {t('common.goToProblems')}
          </ButtonLink>
        }
      />
    </div>
  );
}
